import React from 'react';
import Text from '@kiwicom/orbit-components/lib/Text';
import Stack from '@kiwicom/orbit-components/lib/Stack';
import CountryFlag from '@kiwicom/orbit-components/lib/CountryFlag';
import { ItinerarySegmentStop } from '@kiwicom/orbit-components/lib/Itinerary';
import { HiddenCityData } from '@kiwicom/openapi-sdk/mmb';
import { useIntl as useIntlNitro } from '@kiwicom/nitro/lib/services/intl/context';
import formatCityAndCode from '../services/helpers/formatCityAndCode';

type HiddenStopProps = {
  hiddenArrivalInfo: HiddenCityData;
};

/**
 * Component that renders an unused stop of a THC segment. It shows city and country with its flag
 * and is rendered at the end of the segment.
 * @param hiddenArrivalInfo - information about unused part of the segment
 *
 * @returns HiddenStop component
 */
const HiddenStop = ({ hiddenArrivalInfo }: HiddenStopProps) => {
  const { language } = useIntlNitro();
  const isRtl = language.direction === 'rtl';
  return (
    <ItinerarySegmentStop
      city={
        <Text type="secondary">
          {formatCityAndCode(isRtl, hiddenArrivalInfo.city, hiddenArrivalInfo.code)}
        </Text>
      }
      station={
        <Stack align="center" flex spacing="200">
          <CountryFlag code={hiddenArrivalInfo.flagCountryCode.toUpperCase()} size="small" />
          <Text size="small" type="secondary">
            {hiddenArrivalInfo.country}
          </Text>
        </Stack>
      }
    />
  );
};

export default HiddenStop;
